import { Setting } from '../../types/Setting'
import { toImportStatus } from '../features/import-tool/helpers/importToolHelpers'
import { ImportStatus, ImportType } from '../features/import-tool/types/ImportTool'
import { internalApiserverApi } from './internal-apiserver'

const importStatusSettings: Record<ImportType, string> = {
  [ImportType.Weight]: 'weight_update_status',
  [ImportType.Features]: 'feature_update_status',
}

const importToolApi = internalApiserverApi.enhanceEndpoints({ addTagTypes: ['importStatus'] }).injectEndpoints({
  endpoints: (builder) => ({
    getImportStatus: builder.query<ImportStatus, ImportType>({
      query: (type) => `i/settings/apiserver/${importStatusSettings[type]}`,
      transformResponse: (setting: Setting<Partial<ImportStatus>> | null) => toImportStatus(setting?.data),
      providesTags: (result, error, type) => [{ type: 'importStatus', id: type }],
    }),
    // Multipart: fetchBaseQuery leaves the Content-Type of a FormData body to the browser.
    startImport: builder.mutation<unknown, { type: ImportType; body: FormData }>({
      query: ({ type, body }) => ({ url: `i/dataimport?type=${type}`, method: 'POST', body, responseHandler: 'content-type' }),
      invalidatesTags: (result, error, { type }) => [{ type: 'importStatus', id: type }],
    }),
  }),
})

export const { useGetImportStatusQuery, useStartImportMutation } = importToolApi
